import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DialogService, NotificationService, UrlValidationService } from '@nrwl/common-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSourceService } from '../../../service/datatsource.service';

@Component({
  selector: 'agent-proxy',
  templateUrl: './proxy.component.html',
  styleUrls: ['./proxy.component.scss']
})
export class agentProxyComponent implements OnInit, OnDestroy {
  @Output() closeAgentProxyContainer = new EventEmitter();
  @Output() proxyUrlToTooltip = new EventEmitter();
  @ViewChild('proxyForm', { static: true }) form: NgForm;
  proxyURLValidationMsg: string;
  proxyURLValid: boolean;
  proxyURL: string;
  isProxyRes: boolean;
  isLoading: boolean;
  loaderMessage: string;
  downloadProxyURLPath = '/agent-control-proxy/agent-control-proxy.tar.gz';
  title = 'Add agent control proxy';

  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private readonly notificationService: NotificationService,
    private urlValidationService: UrlValidationService,
    private readonly dataSourceService: DataSourceService,
    private readonly dialogService: DialogService
  ) {}

  ngOnInit() {
    this.getProxyInfo();
  }
  getProxyInfo(): void {
    this.isLoading = true;
    this.loaderMessage = 'Getting proxy details...';
    this.dataSourceService
      .getProxy()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          this.isProxyRes = true;
          this.proxyUrlToTooltip.emit(true);
          if (response && response[0]) {
            this.title = 'Edit agent control proxy';
            this.proxyURL = response[0].proxyServer + ':' + response[0].port;
          } else {
            this.isProxyRes = false;
          }
        },
        () => {
          this.isProxyRes = false;
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  proxyURLChange(): void {
    if (this.proxyURL) {
      const urlValidation = this.urlValidationService.isUrlValid(this.proxyURL);
      if (!urlValidation.isValidUrl) {
        this.form.controls.proxyURL?.setErrors({ regex: 'wrong' });
        this.proxyURLValid = urlValidation.isValidUrl;
        this.proxyURLValidationMsg = urlValidation.errorMessage;
        this.form.controls.proxyURL?.markAsDirty();
      }
    }
  }
  saveProxy(): void {
    this.isLoading = true;
    this.loaderMessage = 'Creating proxy...';
    const proxyUrlObj = this.proxyURL.split(':');
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payloadObj: any = {
      port: proxyUrlObj[1],
      proxyServer: proxyUrlObj[0]
    };
    this.dataSourceService
      .createProxy(payloadObj)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          this.isProxyRes = true;
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'Proxy created successfully';
          this.notificationService.onSuccess(successMsg);
        },
        () => {
          this.isProxyRes = true;
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'There is problem while creating proxy';
          this.notificationService.onFail(successMsg);
        }
      );
  }
  updateProxy(): void {
    this.isLoading = true;
    this.loaderMessage = 'Updating proxy...';
    const proxyUrlObj = this.proxyURL.split(':');
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payloadObj: any = {
      port: proxyUrlObj[1],
      proxyServer: proxyUrlObj[0]
    };
    this.dataSourceService
      .updateProxy(payloadObj)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'Proxy updated successfully';
          this.notificationService.onSuccess(successMsg);
        },
        () => {
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'There is problem while updating proxy';
          this.notificationService.onFail(successMsg);
        }
      );
  }
  deleteProxy(): void {
    this.isLoading = true;
    this.loaderMessage = 'Deleting proxy...';
    const proxyUrlObj = this.proxyURL.split(':');
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payloadObj: any = proxyUrlObj[0];
    this.dataSourceService
      .removeProxy(payloadObj)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          this.proxyURL = '';
          this.isProxyRes = false;
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'Proxy deleted successfully';
          this.notificationService.onSuccess(successMsg);
        },
        () => {
          this.closeAgentProxyContainer.emit(false);
          this.proxyUrlToTooltip.emit(true);
          this.isLoading = false;
          const successMsg = 'There is problem while deleting proxy';
          this.notificationService.onFail(successMsg);
        }
      );
  }
  // eslint-disable-next-line
  removeProxyConfirmation(): void {
    const params = {
      id: 'datasource.proxy',
      callBackService: this,
      callBackFuntion: this.callBackRemoveFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }
  // eslint-disable-next-line
  callBackRemoveFunction(service: any): void {
    service.deleteProxy();
  }
  onCancel(): void {
    this.closeAgentProxyContainer.emit(false);
  }

  close(): void {
    this.closeAgentProxyContainer.emit(false);
  }
}
